export const checkSpecialityToShowIMC = appointment =>{
    //console.log(appointment)
    let idSpe = Number(appointment.speciality.id)

    switch (idSpe){
        case 140:
            return false
        case 67:
            return false
        case 142:
            return false
        case 141:
            return false
        default:
            return true
    }

}